import React from 'react'
import { Link } from "react-router-dom"
import serviceShape4 from "../../images/services/service-shape4.png"
import { useLocation } from "react-router-dom";
import DynamicImage from './DynamicImage';

const ServicesCard = ({ data }) => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  return (
    <>
      {data.serviceCard?.map((card) => (
        <div className="col-lg-4 col-md-6 col-sm-12" key={card.id} data-aos="fade-up" data-aos-duration="1200">
          <div className="single-services-box-item">
            <div className="icon">
              <DynamicImage image={card.image} />
            </div>
            <h3>
              {card.header_menu?.page?.slug ? (
                <Link to={`${card.header_menu?.parent?.slug}/${card.header_menu?.page?.slug}`}>
                  {card.title}
                </Link>
              ) : (
                card?.title || card.title
              )
              }
            </h3>

            <p>
              {card.description}
            </p>
            {isHomePage && (
              card.header_menu?.page?.slug ? (
                <Link
                  to={`/${card.header_menu?.parent?.slug}/${card.header_menu?.page?.slug}`}
                  className="learn-more-btn"
                >
                  <i className="flaticon-right"></i>
                  Learn More
                </Link>
              ) : (
                <Link
                  to="#"
                  onClick={(e) => e.preventDefault()}
                  className="learn-more-btn"
                >
                  <i className="flaticon-right"></i>
                  Learn More
                </Link>
              )
            )}

            <div className="shape">
              <img src={serviceShape4} alt="services" />
            </div>
          </div>
        </div>
      ))}
    </>
  )
}

export default ServicesCard